$(function(){
    $(document).on('click', '[data-clean-inputs]', function(){
        var form = $(this).parents('form');
        var elements = form.find('input, textarea, select');

        elements.each(function(){
            var attr = $(this).attr('data-clean-inputs');
            if(typeof attr == typeof undefined && $(this).attr('type') != "hidden" ) {
                $(this).removeAttr('value');
                $(this).removeAttr('checked');
            }
        })
    });
});